import React from 'react';
import ResourceProperty from '../../../../../../common/resource/ResourceProperty';
import {
  ticketReassignmentBasicInformationPropTypes,
  ticketReassignmentBasicInformationDefaultProps,
} from '../proptypes/TicketReassignmentPropTypes';
import { tzNormalizeDate } from '../../../../../../../utils/date';
import { DATE_TIME_FORMAT } from '../../../../../../../config/locale';
import {
  TICKET_REASSINGMENT_ACCEPT_MERGE,
  TICKET_REASSINGMENT_NEGOTIATION,
  TICKET_REASSINGMENT_RETURN_TYPE,
  TICKET_STATUS,
} from '../../../../../../../config/constants';
import EnumStatus from '../../../../../../common/EnumStatus';

const formatMoney = (value) => {
  if (value === null || value === undefined) return '-';
  return value;
};

const TicketReassignmentBasicInformationResource = ({
  id,
  ticketId,
  ticketDocumentCorrelation,
  previousSeatNumber,
  previousTicketAmount,
  previousSourceLocationName,
  previousDestinationLocationName,
  customer,
  ticketStatus,
  newSeatNumber,
  newDepartureTime,
  newItineraryServiceType,
  ticketAmount,
  newSourceLocationName,
  newDestinationLocationName,
  acceptMerge,
  negotiation,
  refundType,
  comment,
}) => (
  <>
    <ResourceProperty label="ID:">{id || '-'}</ResourceProperty>
    <ResourceProperty label="ID Boleto de Viaje:">
      {ticketId || '-'}
    </ResourceProperty>
    <ResourceProperty label="Número de boleto:">
      {ticketDocumentCorrelation || '-'}
    </ResourceProperty>
    <h3>Itinerario Inicial</h3>
    <ResourceProperty label="Asiento:">
      {previousSeatNumber || '-'}
    </ResourceProperty>
    <ResourceProperty label="Monto S/. :">
      {formatMoney(previousTicketAmount)}
    </ResourceProperty>
    <ResourceProperty label="Embarque:">
      {previousSourceLocationName || '-'}
    </ResourceProperty>
    <ResourceProperty label="Desembarque:">
      {previousDestinationLocationName || '-'}
    </ResourceProperty>
    <ResourceProperty label="Nombre:">
      {customer.fullName || '-'}
    </ResourceProperty>
    <ResourceProperty label="eléfono:">
      {customer.mobilePhone || '-'}
    </ResourceProperty>
    <ResourceProperty label="Email:">{customer.email || '-'}</ResourceProperty>
    <h3>Itinerario Final</h3>
    ENUMv
    <ResourceProperty label="Estado:">
      <EnumStatus enumObject={TICKET_STATUS} enumValue={ticketStatus} />
    </ResourceProperty>
    <ResourceProperty label="Asiento:">{newSeatNumber || '-'}</ResourceProperty>
    <ResourceProperty label="Nuevo horario:">
      {tzNormalizeDate({ date: newDepartureTime, format: DATE_TIME_FORMAT })}
    </ResourceProperty>
    <ResourceProperty label="Servicio:">
      {newItineraryServiceType.name || '-'}
    </ResourceProperty>
    <ResourceProperty label="Monto S/. :">
      {formatMoney(ticketAmount)}
    </ResourceProperty>
    <ResourceProperty label="Embarque:">
      {newSourceLocationName || '-'}
    </ResourceProperty>
    <ResourceProperty label="Desembarque:">
      {newDestinationLocationName || '-'}
    </ResourceProperty>
    <h3>PostVenta</h3>
    <ResourceProperty label="Acepta fusión:">
      <EnumStatus
        enumObject={TICKET_REASSINGMENT_ACCEPT_MERGE}
        enumValue={acceptMerge}
      />
    </ResourceProperty>
    <ResourceProperty label="Negociación:">
      <EnumStatus
        enumObject={TICKET_REASSINGMENT_NEGOTIATION}
        enumValue={negotiation}
      />
    </ResourceProperty>
    <ResourceProperty label="Tipo de devolución:">
      <EnumStatus
        enumObject={TICKET_REASSINGMENT_RETURN_TYPE}
        enumValue={refundType}
      />
    </ResourceProperty>
    <ResourceProperty label="Observación:">{comment || '-'}</ResourceProperty>
  </>
);

TicketReassignmentBasicInformationResource.propTypes = {
  ...ticketReassignmentBasicInformationPropTypes,
};

TicketReassignmentBasicInformationResource.defaultProps =
  ticketReassignmentBasicInformationDefaultProps;

export default TicketReassignmentBasicInformationResource;
